import { Link } from 'react-router';
import { Page } from '@/components/layout/PageHeader';

export default function NotFoundPage() {
  return (
    <Page>
      <p className="text-muted-foreground">
        Page not found.{' '}
        <Link to="/tracker" className="text-primary hover:underline">
          Go to Time Tracker
        </Link>
      </p>
    </Page>
  );
}
